import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { Dialog, TopBar } from '../shared/ui/components';
import { BottomNav } from './BottomNav';

const titles: Record<string, string> = { '/': '主页', '/materials': '样片素材', '/courses': '课程', '/me': '我的', '/my-assets': '我的素材', '/login': '登录 / 注册', '/generation-history': 'AI生成历史', '/terms': '服务条款', '/privacy': '隐私政策' };

export function AppShell() {
  const location = useLocation();
  const { pathname, search } = location;
  const navigationType = useNavigationType();
  const navigate = useNavigate();
  const scrollPositions = useRef(new Map<string, number>());
  const [sessionExpired, setSessionExpired] = useState(false);
  const detail = pathname === '/login' || pathname === '/terms' || pathname === '/privacy' || pathname === '/generation-history' || pathname === '/my-assets' || pathname.startsWith('/generation-history/') || pathname.startsWith('/courses/');
  const title = pathname.startsWith('/generation-history/') ? '生成详情' : pathname.startsWith('/courses/') ? '课程详情' : (titles[pathname] ?? '照型师');

  useEffect(() => {
    const viewport = window.visualViewport;
    const update = () => {
      const height = viewport?.height ?? window.innerHeight;
      const keyboardInset = Math.max(0, window.innerHeight - height - (viewport?.offsetTop ?? 0));
      document.documentElement.style.setProperty('--zxs-visual-viewport-h', `${height}px`);
      document.documentElement.style.setProperty('--zxs-keyboard-inset', `${keyboardInset}px`);
      document.documentElement.toggleAttribute('data-keyboard-open', keyboardInset > 100);
    };
    update();
    viewport?.addEventListener('resize', update);
    return () => viewport?.removeEventListener('resize', update);
  }, []);

  useLayoutEffect(() => {
    const positions = scrollPositions.current;
    const target = navigationType === 'POP' ? positions.get(location.key) ?? 0 : 0;
    window.scrollTo({ top: target, left: 0, behavior: 'auto' });
    return () => { positions.set(location.key, window.scrollY); };
  }, [location.key, navigationType]);

  useEffect(() => {
    const expired = () => setSessionExpired(true);
    window.addEventListener('zxs:session-expired', expired);
    return () => window.removeEventListener('zxs:session-expired', expired);
  }, []);

  return <div className={`app-frame ${detail ? 'app-frame--with-top-bar' : 'app-frame--topless'}`}>{detail && <TopBar title={title} back={() => navigate(-1)} />}<main className={`page-scroll ${detail ? 'page-scroll--detail' : 'page-scroll--topless'}`}><Outlet /></main>{!detail && <BottomNav />}<Dialog open={sessionExpired} title="登录已过期" onClose={() => setSessionExpired(false)} primaryLabel="重新登录" onPrimary={() => { setSessionExpired(false); navigate(`/login?expired=1&returnTo=${encodeURIComponent(pathname + search)}`); }}><p>为了保护账号安全，请重新验证。当前提示词、参数和已上传素材不会丢失。</p></Dialog></div>;
}
